import { styled } from "styled-components";

export const SectionSpacer = styled.div`
  margin-bottom: 4px;
  padding-bottom: 4px;
`